/** @format */

import React from "react";

const EachServiceCard = ({ title, excerpt, icon }) => {
  return (
    <div className="eachservicecard">
      <div className="eachservice-img">
        <img src={icon} alt={title} />
      </div>
      <h2>{title}</h2>
      <p>{excerpt}</p>
    </div>
  );
};

export default EachServiceCard;
